// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3spLO","bigColWidth":"Table_bigColWidth__zvxZE","biggerColWidth":"Table_biggerColWidth__2prPV","row":"Table_row__3T0B4","col":"Table_col__96G1l"};